// extracted by mini-css-extract-plugin
export default {"card":"skillbox-module__card--a08n5","imgContainer":"skillbox-module__imgContainer--roF1T","bubble":"skillbox-module__bubble--E7_9N"};